import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthProvider {

    private readonly _doLogin = new ReplaySubject();
    public readonly doLogin$ = this._doLogin.asObservable();

    private readonly _doLogout = new ReplaySubject();
    public readonly doLogout$ = this._doLogout.asObservable();

    public loggedIn: boolean;

    loginEvent() {
        this.loggedIn = true;
        this._doLogin.next(true);
    }
    
    logoutEvent() {
        this.loggedIn = false;
        this._doLogout.next(true);
    }
}